import { useRef, useState } from 'react'

const useModal = (closeDuration: number = 300) => {
  const [open, setOpen] = useState(false)
  const [processing, setProcessing] = useState(false)
  const closeDurationRef = useRef(closeDuration)

  const reset = () => {
    setOpen(false)
    setProcessing(false)
  }

  return {
    open,
    setOpen,
    processing,
    setProcessing,
    reset,
    closeDuration: closeDurationRef.current,
  }
}

export default useModal
